import { render, staticRenderFns } from "./ChatroomUrlModal.vue?vue&type=template&id=2130e49a&"
import script from "./ChatroomUrlModal.vue?vue&type=script&lang=js&"
export * from "./ChatroomUrlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports